/*eslint no-unused-vars: ["error", { "vars": "local" }]*/
/*global ajax_object */

export function infiniteScrollInit(){
  console.log(document.querySelector('.blog-archive__observer'))
  if($('.blog-archive__observer').length){
    const root = document.querySelector('.blog-archive__observer');
    let options = {
      threshold: 1,
    }
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.intersectionRatio == 1){
          $('body').addClass('loading')

          if($('.blog-archive')){
            let offset = $('article.article').length
            let featuredPost = $('article.article--featured') && $('article.article--featured').attr('data-id')
    
            if(offset){
              $.ajax({
                'type': 'POST',
                'url': ajax_object.ajaxurl,
                'data': {
                  'postOffset': offset,
                  'featuredPost': featuredPost,
                  'action': ajax_object.action,
                },
              })
              .done(function(response){
                setTimeout(function(){
                  $('body').removeClass('loading')
                  if(response && response.data){
                    let newPost = $(response.data).filter(function(){
                      if($(this).hasClass('article')) return $(this)
                    })

                    $('.blog-archive__grid').append(response.data)
                      
                    if(newPost.length < ajax_object.postsPerPage)
                      $('.blog-archive__observer').remove()
                    
                  }else{
                    $('.blog-archive__observer').remove()
                  }
                }, 500)
              })
            }
          }
        }
      })
    }, options)

    observer.observe(root)
  }
}